<template>
	<div>
		<div class="pt-1">
			<div class="form-desc  pt-3">
				{{ t('editVariablesDescText','editVariablesDescText') }}
			</div>
		</div>
		<div class="col-4 pl-0">
			<transition name="fade">
        <ResponseInfo v-if="getResponseInfo.responseName == 'editTextVariables'" class=""/>
      </transition>			
			<div class="table-responsive">
				<b-table striped hover fixed v-bind:items="getTextVariables" v-bind:fields="fields" id="email-variables-table">
					<template v-slot:head(variableName)="data">
						<span >{{ t(data.label, data.label) }}</span>
					</template>
					<template v-slot:head(variableDelete)="data">
						<span >{{ t(data.label, data.label) }}</span>
					</template>
					<template v-slot:cell(variableName)="data">
						<span >{{ data.item.name }}</span>
					</template>
					<template v-slot:cell(variableDelete)="data">
						<fontAwesomeIcon :icon="['far', 'window-close']" size="2x" class="closeButton" v-bind:value="{id: data.item.id}" @click="openDeleteModal(t('deleteVariableModalTitle','deleteVariableModalTitle'), data.item.id, data.item.name, $event.target)"></fontAwesomeIcon>
					</template>				
				</b-table>
			</div>
			<form v-on:submit.prevent="addVariable">
				<div class="row block-input-row form-group">
					<div class="col-4">{{ t('editVariablesNewName', 'editVariablesNewName') }}</div>
					<div class="col-8">
						<input class="form-control" v-model="newTextVariableName" type="text">
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-right">
						<button type="submit" class="btn btn-primary" :disabled="!newTextVariableName">{{ t('editVariablesAddBtn','editVariablesAddBtn') }}</button>
					</div>
				</div>
			</form>
		</div>		
		<!-- DELETE MODAL -->
		<b-modal class="modal-lg" :id="deleteModal.id" :title="deleteModal.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetDeleteModal">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ deleteModal.title }} ?</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">                   
					<div class="col-lg-12 py-2"><span class="">{{ t('deleteEmailVariableModalQuestion','deleteEmailVariableModalQuestion') }} </span> <span class="font-weight-bold">{{ deleteModal.varName }} ?</span></div>                     
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" @click="deleteVariable">Yes</button>
			</template>
		</b-modal>
		<div v-if="darkBackgroundDisplay" class="modal-backdrop show"></div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'EditVariables',
	components: {
		ResponseInfo
	},
	data() {
		return {
			fields: [
				{key: 'variableName', label: 'variableName', thClass: 'hover-pointer'},
				{key: 'variableDelete', label: 'variableDelete', thClass: 'text-center', tdClass: 'text-center', thStyle: 'width: 40px'},
			],
			deleteModal: {
				id: 'delete-variables-modal',
				title: '',
				varId: '',
				varName: ''
			},
			darkBackgroundDisplay: false,
			newTextVariableName: ''
		}
	},
	methods: {
		openDeleteModal(title, varId, varName, button) {
			this.deleteModal.title = title
			this.deleteModal.varId = varId
			this.deleteModal.varName = varName
			this.darkBackgroundDisplay = true
			this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
		},
		deleteVariable() {
			this.$store.dispatch('emailVariablesStore/deleteTextVariable', {
				varId: this.deleteModal.varId
			}).then(() => {
				this.$store.state.emailVariablesStore.docTypeContents = []
				this.$parent.$parent.$parent.$refs.editContentsChild.documentType = null
				this.$root.$emit('bv::hide::modal', this.deleteModal.id)
			})
		},
		resetDeleteModal() {
			this.deleteModal.title = ''
			this.deleteModal.varId = ''
			this.deleteModal.varName = ''
			this.darkBackgroundDisplay = false
		},
		addVariable() {
			this.$store.dispatch('emailVariablesStore/addTextVariable', {
				name: this.newTextVariableName
			}).then(() => {
				if(this.getResponseInfo.key == 'addTextVariableNameSuccess') {
					this.newTextVariableName = '' 
					this.$store.state.emailVariablesStore.docTypeContents = []
					this.$parent.$parent.$parent.$refs.editContentsChild.documentType = null
				}	
			})
		}
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel', 'getUserDetails']),
		...mapGetters('emailVariablesStore', ['getTextVariables'])
	},	
  created() {
		this.$store.dispatch('emailVariablesStore/getTextVariablesList')
	}
}
</script>

<style scoped>
  .closeButton {
    color: #dd1111;
    cursor: pointer;
  }
  .block-input-row {
    align-items: center;
    text-align: left;
  }
</style>